import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken, updateRoles } from "./loginService"
import { criptografarMD5 } from "./cryptographyService"
import * as axios from 'axios';

export default {
    obterUsuariosAsync,
    enviarUsuarioAsync,
    editarUsuarioAsync,
	downloadLista
}

export const obterUsuariosAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Usuario/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarUsuarioAsync = async (nome, email, telefone, matricula, idCargo, idPerfil, idLocal, departamentos, avatar) => {
    var login = criptografarMD5(email);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ nome, login, email, telefone, matricula, idCargo, idPerfil, idLocal, departamentos, avatar })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Usuario`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarUsuarioAsync = async (id, nome, email, ativo, telefone, matricula, idCargo, idPerfil, idLocal, departamentos, avatar, reset) => {
    var login = null;
    if (email && email != '')
        login = criptografarMD5(email);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, nome, login, email, ativo, telefone, matricula, idCargo, idPerfil, idLocal, departamentos, avatar })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Usuario/atualizar/` + reset, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(response => {
			if(response){
                updateRoles();
            }
        });
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Usuario/downloadUsuarios`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'usuarios' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}